<template>
  <el-select :disabled="disabled" :multiple='multiple' clearable @change="handleChange" :value="data.value"
             placeholder="请选择" @clear="handleChange()" filterable>
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in sitePoint" :key="index"></el-option>
  </el-select>
</template>

<script>
    import {getCascade} from '@/services/deviceType'

    export default {
        name: 'SitePoint',
        props: {
            value: {},
            operatorIds: {
                default() {
                    return []
                }
            },
            operator: {

            },
            disabled: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {data: {}, sitePoint: []}
        },
        mounted() {
            this.loadData();
        },
        watch: {
            operatorIds: {
                immediate: true,
                handler(value) {
                    if (value) {
                        this.loadData(value)
                    } else {
                        this.sitePoint = [];
                    }
                },
            },
            operator: {
                immediate: true,
                handler(value) {
                    if (value) {
                        this.loadData2(value)
                    } else {
                        this.sitePoint = [];
                    }
                },
            },
            value: {
                immediate: true,
                handler(value) {
                    if (value) {
                        this.data = value;
                    } else {
                        this.data = {};
                    }

                }
            }
        },
        methods: {
            handleChange(value) {

                let find = this.sitePoint.find((item, i) => {
                    return item.value == value
                });
                if (find == undefined) {
                    find = {};
                }
                this.$emit("input", find)
                this.$emit("change", find)
                this.data = find;
            },
            async loadData(operatorIds) {
                this.sitePoint = [];
                this.data = {};
                this.$emit("input", {})
                if (operatorIds) {
                    const response = await getCascade({operatorIds: operatorIds});
                    if (response && response.data.SiteName) {
                        this.sitePoint = response.data.SiteName.map((item, i) => {
                            return {name: item.name, value: item.id, allianceBrand: item.allianceBrand}
                        })
                        //  console.log(this.sitePoint);
                        //  this.$emit('getson', this.sitePoint)
                    }

                }
            },

            async loadData2(operator) {
                this.sitePoint = [];
                this.data = {};
                this.$emit("input", {})
                if (operator) {
                    const response = await getCascade({operatorIds: operator.value});
                    if (response && response.data.SiteName) {
                        this.sitePoint = response.data.SiteName.map((item, i) => {
                            return {name: item.name, value: item.id, allianceBrand: item.allianceBrand}
                        })
                        //  console.log(this.sitePoint);
                        //  this.$emit('getson', this.sitePoint)
                    }

                }
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/SitePoint.vue